var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PanelHeading',{attrs:{"title":_vm.lc.title,"description":_vm.lc.description,"header":"","headerColor":"primary","wave":""},scopedSlots:_vm._u([{key:"subtitle",fn:function(){return [_vm._v(" "+_vm._s(_vm.lc.welcome)+", "),_c('b',[_vm._v(_vm._s(_vm.username))])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }